import Vue from 'vue';
import VueMask from 'v-mask';
import eventBus from "./EventBus";

import CodePictureComponent from './vue_components/ocrComponent/index.vue';
import SwitcherComponent from './vue_components/phoneEmailSwitcher/index.vue';
import MultipleOCR from './vue_components/muplipleSerialOCR/index.vue';
import PropaneValidation from './vue_components/validationComponent/propane/index.vue';
import WizardWrapper from "./vue_components/wizardRedemption/wrapper.vue";
import WizardForm from "./vue_components/wizardRedemption/form.vue";
import WorkflowCodes from './vue_components/wizardRedemption/workflowCodes/Index.vue';
import UploadCodeModal from './vue_components/wizardRedemption/workflowCodes/uploadCodeModal.vue';
import ChooseTypeModal from "./vue_components/wizardRedemption/workflowCodes/chooseTypeModal.vue";
import WizardStepValidator from "./vue_components/wizardRedemption/wizardStepValidator.vue";

Vue.use(VueMask);
Vue.prototype.$eventBus = eventBus;

const promoApp = new Vue({
  el: 'main',
  components: {
    'wizard-content-wrapper': WizardWrapper,
    'wizard-form-wrapper': WizardForm,
    'code-picture': CodePictureComponent,
    'multiple-ocr-codes': MultipleOCR,
    'propane-code': PropaneValidation,
    switcher: SwitcherComponent,
    'workflow-codes': WorkflowCodes,
    UploadCodeModal,
    ChooseTypeModal,
    WizardStepValidator,
  },
});

window.showPopup = function(container) {
  $('.' + container).addClass('opened');
};
